module.exports = __webpack_public_path__ + "img/winery_afternoon_tea3.5f99d7d1.png";